export default __webpack_public_path__ + "static/media/330_dummy2016-mode01-de-mobile.6f616630.png";